import { wrap } from '@suspensive/react';
import { useSuspenseQueries } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';
import { createContext } from 'react';

import { query } from '@/api/query';
import ProductLoading from '@/app/components/ProductLoading';
import { DEFAULT_PERMISSION } from '@/constants/Permission';

type PermissionsContextProps = {
  permission: Permission;
};

const initialState: PermissionsContextProps = {
  permission: { ...DEFAULT_PERMISSION },
};

export const PermissionsContext = createContext(initialState);

const PermissionsProvider = wrap
  .Suspense({
    clientOnly: true,
    fallback: <ProductLoading />,
  })
  .on<PropsWithChildren>(({ children }) => {
    const [userPermissionQuery] = useSuspenseQueries({
      queries: [{ ...query.user.permissions(), staleTime: 1_800_000 }],
    });

    return (
      <PermissionsContext.Provider
        value={{
          permission: userPermissionQuery.data.data.reduce(
            (prev, cur) => {
              return Object.assign(prev, { [cur]: true });
            },
            {} as Record<PermissionKey, boolean>
          ),
        }}
      >
        {children}
      </PermissionsContext.Provider>
    );
  });

export default PermissionsProvider;
